export default function refreshFormsList() {
  window.dispatchEvent(
    new StorageEvent('storage', {
      key: 'carcheck.forms',
    }),
  );
}
